var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navigation-tabs-smooth__tabs",
      on: { touchmove: _vm.$_handleDefaultTouchMove }
    },
    [
      _c(
        "div",
        {
          ref: "scroller",
          staticClass: "navigation-tabs-smooth__scroller",
          on: { click: _vm.$_handleClick }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }